module.exports = __webpack_public_path__ + "img/coupon.9739f610.png";